
		<div
			class="form-group"
			[formGroup]="OBJ_form_group"
			[class.has-error]="isInvalid()">
			<ng-template #tooltipTemplate>
				<div [innerHtml]="getHint()|translate"></div>
			</ng-template>
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
				<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
				   [tooltip]="tooltipTemplate"
				   placement="top"
				   triggers="click"
				   containerClass="tig-tooltip"
				   delay="50"></i> <span *ngIf="isRequired()" class="tgi-asterisk"> *</span> </label>
			<div class="col-lg-8">
				<input
					title="{{getHint()|translate}}"
					class="form-control"
					[placeholder]="getLabelName()|translate"
					[formControlName]="OBJ_field_config.name"
					(blur)="setValue($event)"
				/>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
				<tig-form-error [OBJ_form_control]="getFormControl()"></tig-form-error>
				<tig-form-warning [OBJ_form_control]="getFormControl()" [field_config]="getFieldConfig()" ></tig-form-warning>
				<div *ngIf="extern_link.has">
					<a href="{{extern_link.href}}"
					   target="{{extern_link.target}}k">
						{{extern_link.text|translate}}
						<i class="fa fa-external-link"></i> </a>
				</div>
			</div>
		</div>
	